export const spacingSmall = 2;
export const spacing = 4;
export const spacingLarge = 6;
export default spacing;
